import { ViewLarge, ViewMedium, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import React, { FunctionComponent } from 'react';
import { UitkLayoutFlexItem, UitkLayoutFlex } from 'uitk-react-layout-flex';
import { UitkLayoutGrid, MinMax } from 'uitk-react-layout-grid';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';
import LodgingCard from './lodging-card';
interface Props {
  formatContent(label: string): string;
}
const LodgingSection: FunctionComponent<Props> = ({ formatContent }) => {
  const connectivityHubCard = (
    <LodgingCard
      title={formatContent('brandsSection.Supply.cards.connectivityHub')}
      description={formatContent('brandsSection.Supply.cards.connectivityHub.description')}
      href="https://developers.expediagroup.com/supply/lodging"
      linkTitle={formatContent('brandsSection.Supply.cards.connectivityHub.linkText')}
      type="expedia"
      imageLink="/docs/images/expedia-logo.svg"
    />
  );

  const vrboHubNode = (
    <LodgingCard
      title={formatContent('brandsSection.Supply.cards.vrbo')}
      description={formatContent('brandsSection.Supply.cards.vrbo.description')}
      href="https://integration-central.vrbo.com/t"
      linkTitle={formatContent('brandsSection.Supply.cards.vrbo.linkText')}
      type="vrbo"
      imageLink="/docs/images/vrbo-logo.svg"
    />
  );
  return (
    <Viewport>
      <ViewLarge>
        <UitkLayoutFlexItem dir="column" className="home-spacing marketing-page-width">
          <UitkLayoutFlex direction="row" justifyContent="space-between">
            <UitkLayoutFlexItem>
              <UitkLayoutFlex direction="column">
                <UitkLayoutFlexItem>{connectivityHubCard}</UitkLayoutFlexItem>
                <UitkLayoutFlexItem>{vrboHubNode}</UitkLayoutFlexItem>
              </UitkLayoutFlex>
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem dir="column">
              <UitkSpacing margin={{ inlinestart: 'twelve' }}>
                <UitkLayoutFlex direction="column" justifyContent="center">
                  <UitkSpacing margin={{ blockend: 'six' }}>
                    <UitkText size={600} theme="emphasis">
                      {formatContent('brandsSection.Supply')}
                    </UitkText>
                  </UitkSpacing>
                  <UitkLayoutGrid columns={[MinMax('40x', '70x'), '1fr', 'min-content']} space="two">
                    <UitkText size={500} theme="default">
                      {formatContent('brandsSection.Supply.description')}
                    </UitkText>
                  </UitkLayoutGrid>
                </UitkLayoutFlex>
              </UitkSpacing>
            </UitkLayoutFlexItem>
          </UitkLayoutFlex>
        </UitkLayoutFlexItem>
      </ViewLarge>

      <ViewMedium>
        <UitkLayoutFlexItem dir="column" className="home-spacing marketing-page-width">
          <UitkLayoutFlex direction="column" justifyContent="space-between">
            <UitkLayoutFlexItem dir="column">
              <UitkSpacing margin={{ blockend: 'twelve' }}>
                <UitkLayoutFlex direction="column" justifyContent="center" alignItems="center">
                  <UitkSpacing margin={{ blockend: 'six' }}>
                    <UitkText size={600} theme="emphasis">
                      {formatContent('brandsSection.Supply')}
                    </UitkText>
                  </UitkSpacing>
                  <UitkText size={500} theme="default">
                    {formatContent('brandsSection.Supply.description')}
                  </UitkText>
                </UitkLayoutFlex>
              </UitkSpacing>
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem>
              <UitkLayoutFlex direction="column">
                <UitkLayoutFlexItem>{connectivityHubCard}</UitkLayoutFlexItem>
                <UitkLayoutFlexItem>{vrboHubNode}</UitkLayoutFlexItem>
              </UitkLayoutFlex>
            </UitkLayoutFlexItem>
          </UitkLayoutFlex>
        </UitkLayoutFlexItem>
      </ViewMedium>
      <ViewSmall>
        <UitkLayoutFlexItem dir="column" className="home-spacing marketing-page-width">
          <UitkLayoutFlex direction="column" justifyContent="space-between">
            <UitkLayoutFlexItem dir="column">
              <UitkSpacing margin={{ blockend: 'twelve' }}>
                <UitkLayoutFlex direction="column" justifyContent="center" alignItems="center">
                  <UitkSpacing margin={{ blockend: 'six' }}>
                    <UitkText size={600} theme="emphasis">
                      {formatContent('brandsSection.Supply')}
                    </UitkText>
                  </UitkSpacing>
                  <UitkText size={300} theme="default">
                    {formatContent('brandsSection.Supply.description')}
                  </UitkText>
                </UitkLayoutFlex>
              </UitkSpacing>
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem>
              <UitkLayoutFlex direction="column">
                <UitkLayoutFlexItem>{connectivityHubCard}</UitkLayoutFlexItem>
                <UitkLayoutFlexItem>{vrboHubNode}</UitkLayoutFlexItem>
              </UitkLayoutFlex>
            </UitkLayoutFlexItem>
          </UitkLayoutFlex>
        </UitkLayoutFlexItem>
      </ViewSmall>
    </Viewport>
  );
};

export default LodgingSection;
